/* FilmFix: homepage hero carousel (latest featured posts) */
(function () {
    /* Long titles get a smaller size (see .is-long-title in filmfix.css) so the
       excerpt and "Lees verder" button still fit the fixed-height desktop slide.
       Runs for the single-slide fallback too, which has no data attribute. */
    var LONG_TITLE_CHARS = 55;
    Array.prototype.forEach.call(document.querySelectorAll('.ff-hero-slide'), function (slide) {
        var title = slide.querySelector('.ff-hero-title');
        if (title && title.textContent.trim().length > LONG_TITLE_CHARS) {
            slide.classList.add('is-long-title');
        }
    });

    var root = document.querySelector('[data-hero-carousel]');
    if (!root) return;

    var track = root.querySelector('[data-hero-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (slides.length < 2) return;

    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var dotsWrap = root.querySelector('[data-hero-dots]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var AUTOPLAY_MS = 6000;
    var index = 0;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
        slides.forEach(function (slide, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ff-hero-dot';
            dot.setAttribute('aria-label', 'Ga naar artikel ' + (i + 1));
            dot.addEventListener('click', function () {
                go(i);
                restart();
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
        });
    }

    function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        slides.forEach(function (slide, n) {
            slide.setAttribute('aria-hidden', n === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === index);
        });
    }

    function stop() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }

    function start() {
        if (reduceMotion.matches || timer) return;
        timer = setInterval(function () {
            go(index + 1);
        }, AUTOPLAY_MS);
    }

    function restart() {
        stop();
        start();
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', function () {
            go(index - 1);
            restart();
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function () {
            go(index + 1);
            restart();
        });
    }

    /* Pause while the visitor is reading or tabbing through the hero */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) start();
    });

    /* Swipe on touch screens (arrows are hidden on mobile) */
    var touchStartX = null;
    track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        stop();
    }, {passive: true});
    track.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        touchStartX = null;
        start();
    }, {passive: true});

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            stop();
        } else {
            start();
        }
    });

    go(0);
    start();
})();
